import { Chip } from '@mui/material'
import { allColors } from '../../theme'

export interface IChipProps {
    label?: string
    size?: 'small' | 'medium'
    width?: string
}

export interface IColorChipProps extends IChipProps {
    color: keyof typeof allColors
}

export const ColorChip = ({ size, width = '80px', label = 'valid', color }: IColorChipProps) => (
    <Chip
        label={label}
        size={size}
        sx={{
            textTransform: 'uppercase',
            backgroundColor: allColors[color][300],
            color: allColors[color][800],
            fontWeight: 500,
            width,
        }}
    />
)

export const ValidChip = ({ size, width = '80px', label = 'valid' }: IChipProps) => (
    <ColorChip size={size} width={width} label={label} color='green' />
)

export const InvalidChip = ({ size, width = '80px', label = 'invalid' }: IChipProps) => (
    <ColorChip size={size} width={width} label={label} color='red' />
)
